import { TFunction } from 'i18next';
import { SearchFilters } from '../../../types/search';
import { FilterConfig } from './config';
import { Topic } from '../../../types/topic';
import { FILTER_OPTIONS } from '../../../constants/search';

export const useSelectedValues = (
  config: FilterConfig,
  filters: SearchFilters,
  t: TFunction,
  topics?: Topic[]
): string[] => {
  const selectedValues = config.getSelectedValues(filters);
  if (selectedValues.length === 0) return [];

  if (config.id === 'topics' && topics) {
    return selectedValues.map(value => {
      const topic = topics.find(t => t.id === value);
      return topic ? topic.title : value;
    });
  }

  if (config.id === 'duration') {
    return selectedValues.map(value => {
      const option = FILTER_OPTIONS.DURATION.find(opt => opt.value === value);
      if (!option) return value;
      if ('max' in option) {
        return t(option.translationKey, { min: option.min, max: option.max });
      }
      return t(option.translationKey, { min: option.min });
    });
  }

  return selectedValues.map(value => t(`${config.translationPrefix}.${value}`));
}; 